import React, {Component} from 'react';
import {HeadingSmall, ParagraphLarge} from 'baseui/typography';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import {Button, KIND, SIZE} from 'baseui/button';
import * as ROUTES from '../../Routes';
import Carousel from '../../Carousel';
import appStoreBadge from '../../images/platforms/ios/app_store_logo_light';

import ios_image1 from '../../images/platforms/ios/iphone/ios_image1.png';
import ios_image2 from '../../images/platforms/ios/iphone/ios_image2.png';
import ios_image3 from '../../images/platforms/ios/iphone/ios_image3.png';
import ios_image4 from '../../images/platforms/ios/iphone/ios_image4.png';
import ios_image5 from '../../images/platforms/ios/iphone/ios_image5.png';
import ios_image6 from '../../images/platforms/ios/iphone/ios_image6.png';

const centerProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

class Apple extends Component {
    renderDetails = () => {
        return <FlexGrid>
            <FlexGridItem>
                <FlexGrid backgroundColor={'primaryB'} style={{padding: '20px'}}>
                    <FlexGridItem><HeadingSmall margin={0}>EncLock for Apple Devices</HeadingSmall></FlexGridItem>
                    <FlexGridItem>
                        <ParagraphLarge>
                        EncLock is now available on the Mac App Store, bringing the latest version with new features and security improvements. This version supports Mac, iPhone, and iPad, allowing you to safeguard your files, passwords, notes, credit card details, and more across all your Apple devices. Whether you're at home or on the go, EncLock ensures that your private information remains safe on all your Apple devices.
                        </ParagraphLarge>

                        <ParagraphLarge>
                        Head to the App Store to install EncLock and enjoy seamless protection of your data.
                        </ParagraphLarge>
                    </FlexGridItem>
                    <FlexGridItem {...centerProps}>
                        <Button
                            href={ROUTES.ENCLOCK_MACOS_INSTALL}
                            $as={'a'}
                            target={"_blank"}
                            size={SIZE.mini}
                            kind={KIND.tertiary}>{appStoreBadge()}</Button>
                    </FlexGridItem>
                </FlexGrid>
            </FlexGridItem>
        </FlexGrid>
    };

    render = () => {
        return <div>
            {this.renderDetails()}

            <HeadingSmall style={{textAlign: 'center'}}>EncLock on iPhone</HeadingSmall>
            <Carousel
                images={[ios_image1, ios_image2, ios_image3, ios_image4, ios_image5, ios_image6]}
                captions={[
                    "No sign up is needed to use EncLock! Go ahead and login with any email and all your information will be stored locally on your device. This is an offline version of EncLock and your information will never leave your device's safety.",
                    "Store Passwords, Files, Credit Cards, Notes and more! Organize them easily with folders and move them around as needed with ease.",
                    "Storing your passwords was never easier. Viewing them or copying them is just a click away!",
                    "You don't know what your next password should be? Generate a safe password from Password Generator!",
                    "Safely store you Credit Cards with EncLock! You can save as many of them as you like and organize them with folders.",
                    "Everyone needs something to take notes on... With EncLock you have a dedicated Notes section where you can store your notes away and also organize easily in folders."
                ]}
            />
        </div>
    };
}

export default Apple;
